import React, { Component } from "react";
import { get, post } from "../lib/axios";
import { SERVER_URL } from "../config";

class OrderService extends Component {
	static async trackOrder(orderId: string, uuid?:string) {
        if(uuid) {
            return await get({
                url: `${SERVER_URL}/v3/order/link/track/`,
                params: { orderId },
                uuid
            }, true);
        } else {
            return await get({
                url: `${SERVER_URL}/v3/order/track/${orderId}`,
            });
        }

	}

	static async addToCart(payload: any, restaurantId: string) {
		return await post({
			url: `${SERVER_URL}/v3/user/cart/${restaurantId}`,
			data: payload,
		});
	}

	static async createOrder(payload: any) {
		return await post({
			url: `${SERVER_URL}/v3/order/create`,
			data: payload,
		});
	}

	static async getOrderStatus(orderId: string) {
		return get({
			url: `${SERVER_URL}/v1/order/status/${orderId}`,
		});
	}

	static async openShutter(payload: any, uuid?:string) {
        if(uuid) {
            return post({
                url: `${SERVER_URL}/v3/order/link/item/collect`,
                data: payload,
                params: { orderId: payload.orderId },
                uuid
            }, true);
        } else {
            return post({
                url: `${SERVER_URL}/v3/order/item/collect`,
                data: payload,
            });
        }
	}

	static async openShutterV4(payload: any, uuid?:string) {
        if(uuid) {
            return post({
                url: `${SERVER_URL}/v4/order/link/item/collect`,
                data: payload,
                params: { orderId: payload.orderId },
                uuid
            }, true);
        } else {
            return post({
                url: `${SERVER_URL}/v4/order/item/collect`,
                data: payload,
            });
        }
	}

	static async getOrderDetails(orderId: string) {
		return get({
			url: `${SERVER_URL}/v3/order/detail/${orderId}`,
		});
	}

	static async getOrderStartTime(kioskId: string) {
		const url = `${SERVER_URL}/v3/order/time/start/${kioskId}`;
		return get({ url });
	}
}

export default OrderService;
